module.exports = __webpack_public_path__ + "img/productTitle1.3941cb8e.png";